"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    pagination: ()=>pagination,
    paginationVariants: ()=>paginationVariants
});
const tv_cjs_namespaceObject = require("../../variants/tv.cjs");
const flexRowCenter = 'flex flex-row items-center';
const pagination = (0, tv_cjs_namespaceObject.tv)({
    slots: {
        container: [
            'advanced-pagination flex w-full flex-col items-center gap-4',
            'md:flex-row md:items-stretch md:justify-between'
        ],
        pageControls: flexRowCenter,
        pageInfo: `${flexRowCenter} gap-4`,
        indexLabel: `${flexRowCenter} shrink-0 gap-1`,
        pageSizeControls: `${flexRowCenter} gap-3 whitespace-nowrap`
    }
});
const paginationVariants = pagination;
exports.pagination = __webpack_exports__.pagination;
exports.paginationVariants = __webpack_exports__.paginationVariants;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "pagination",
    "paginationVariants"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
